import { z } from 'zod';

export const taxonomyInstructionZod = z.object({
  name: z.string(),
  type: z.string(),
  description: z.string(),
  attributes: z.record(z.string(), z.array(z.string())).transform((record) => {
    //REMARK: We are manually updated the taxonomy. This is a hack to meet our short-term needs.
    if (record['school_bus_stop_sign'] == null) {
      return record;
    }
    record['school_bus_stop_sign'] = record['school_bus_stop_sign'].map(
      (val) => {
        if (val === 'flashing.red') {
          return 'flashing_red';
        }
        if (val === 'flashing.yellow') {
          return 'flashing_yellow';
        }

        return val;
      }
    );

    return record;
  }),
  categories: z.record(z.string(), z.array(z.string())),
  temporal_attributes: z.record(z.string(), z.array(z.string())).nullable(),
  enrich_categories: z.record(z.string(), z.array(z.string())).nullable(),
});
export const taxonomyInstructionRespZod = z.array(taxonomyInstructionZod);
export type TaxonomyInstruction = z.infer<typeof taxonomyInstructionZod>;
export type TaxonomyInstructionResp = TaxonomyInstruction[];

export const taxonomyInstructionSetZod = z.object({
  name: z.string(),
  comment: z.string(),
  isdefault: z.boolean(),
  instructions: taxonomyInstructionRespZod,
});
export const taxonomyInstructionSetRespZod = z.array(taxonomyInstructionSetZod);
export type TaxonomyInstructionSet = z.infer<typeof taxonomyInstructionSetZod>;
export type TaxonomyInstructionSetResp = TaxonomyInstructionSet[];
